import { render, staticRenderFns } from "./trackInfo.vue?vue&type=template&id=4bd65aa0&scoped=true&"
import script from "./trackInfo.vue?vue&type=script&lang=js&"
export * from "./trackInfo.vue?vue&type=script&lang=js&"
import style0 from "./trackInfo.vue?vue&type=style&index=0&id=4bd65aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd65aa0",
  null
  
)

export default component.exports